import { useSelector } from 'react-redux';

import {
  alpha3CountriesSelector,
  campusSelector,
  validLoanCurrenciesSelector,
} from '../../reducers/selectors';

const useCampusCountryCurrency = () => {
  const currencies = [
    { value: 'EUR', label: 'EUR', symbol: '€' },
    { value: 'GBP', label: 'GBP', symbol: '£' },
    { value: 'USD', label: 'USD', symbol: '$' },
  ];
  const validLoanCurrencies = useSelector(validLoanCurrenciesSelector);
  const countries = useSelector(alpha3CountriesSelector);
  const campus = useSelector(campusSelector);
  const defaultCurrency = 'GBP';
  const { country: campusCountry } = campus;
  const matchingCountry = countries.reduce((prev, curr) => {
    return curr.value === campusCountry ? curr : prev;
  }, null);

  const campusCurrency = matchingCountry?.currency;

  // This is for when the campus or countries aren't present
  const currency = campusCurrency ? campusCurrency : defaultCurrency;
  const loanCurrencies = validLoanCurrencies.length > 0 ? validLoanCurrencies : currencies;

  return [currency, loanCurrencies];
};

export default useCampusCountryCurrency;
